var map = {
	"./00-imed-2026-group-photo.jpeg": 9939,
	"./01-imed-2026-award-ceremony.jpeg": 9946,
	"./02-imed-2026-felicitation.jpeg": 5406,
	"./2026-inti-networking-candid.jpeg": 9013,
	"./2026-inti-spectrum-networking.jpeg": 6683,
	"./2026-malaysia-delegation-group.jpeg": 1172,
	"./2026-sunway-university-felicitation.jpeg": 5666,
	"./2026-tbr-dr-haslina-tea-session.jpeg": 8254,
	"./2026-tbr-great-conversations-promo.jpeg": 8077,
	"./2026-tbr-jamal-zaidi-global-impact.jpeg": 1777,
	"./2026-tbr-prof-ketan-certificate.jpeg": 6862,
	"./2026-tbr-prof-ketan-conversation.jpeg": 2100,
	"./2026-tbr-prof-ketan-kotecha-feature.jpeg": 7999,
	"./2026-tbr-prof-peter-shepard.jpeg": 8543,
	"./2026-tbr-team-selfie.jpeg": 4315,
	"./2026-tea-before-research-solo.jpeg": 6006,
	"./2026-tic-conference-welcome.jpeg": 9206,
	"./WhatsApp Image 2025-11-17 at 07.02.19 (1).jpeg": 2681,
	"./WhatsApp Image 2025-11-17 at 07.02.19 (2).jpeg": 7374,
	"./WhatsApp Image 2025-11-17 at 07.02.19 (3).jpeg": 5531,
	"./WhatsApp Image 2025-11-17 at 07.02.19.jpeg": 1683,
	"./WhatsApp Image 2025-11-17 at 07.02.20 (1).jpeg": 4985,
	"./WhatsApp Image 2025-11-17 at 07.02.20.jpeg": 883,
	"./WhatsApp Image 2025-11-17 at 07.02.21 (1).jpeg": 422,
	"./WhatsApp Image 2025-11-17 at 07.02.21.jpeg": 5580,
	"./WhatsApp Image 2025-11-17 at 07.02.22 (1).jpeg": 4035,
	"./WhatsApp Image 2025-11-17 at 07.02.22 (2).jpeg": 5508,
	"./WhatsApp Image 2025-11-17 at 07.02.22 (3).jpeg": 6673,
	"./WhatsApp Image 2025-11-17 at 07.02.22.jpeg": 5181,
	"./WhatsApp Image 2025-11-17 at 07.02.23 (1).jpeg": 4208,
	"./WhatsApp Image 2025-11-17 at 07.02.23 (2).jpeg": 8831,
	"./WhatsApp Image 2025-11-17 at 07.02.23 (3).jpeg": 3490,
	"./WhatsApp Image 2025-11-17 at 07.02.23.jpeg": 4966,
	"./WhatsApp Image 2025-11-17 at 07.02.24 (1).jpeg": 629,
	"./WhatsApp Image 2025-11-17 at 07.02.24 (2).jpeg": 442,
	"./WhatsApp Image 2025-11-17 at 07.02.24 (3).jpeg": 5495,
	"./WhatsApp Image 2025-11-17 at 07.02.24 (4).jpeg": 7252,
	"./WhatsApp Image 2025-11-17 at 07.02.24.jpeg": 2175,
	"./WhatsApp Image 2025-11-17 at 07.02.25 (1).jpeg": 5714,
	"./WhatsApp Image 2025-11-17 at 07.02.25 (3).jpeg": 480,
	"./WhatsApp Image 2025-11-17 at 07.02.25.jpeg": 1688,
	"./WhatsApp Image 2025-11-17 at 07.02.26 (1).jpeg": 1679,
	"./WhatsApp Image 2025-11-17 at 07.02.26 (2).jpeg": 6912,
	"./WhatsApp Image 2025-11-17 at 07.02.26 (3).jpeg": 7101,
	"./WhatsApp Image 2025-11-17 at 07.02.26.jpeg": 6601,
	"./WhatsApp Image 2025-11-17 at 07.02.27.jpeg": 5026,
	"./WhatsApp Image 2025-11-17 at 07.08.22 (1).jpeg": 8345,
	"./WhatsApp Image 2025-11-17 at 07.08.22.jpeg": 5443,
	"./WhatsApp Image 2025-11-17 at 07.08.23 (1).jpeg": 1782,
	"./WhatsApp Image 2025-11-17 at 07.08.23 (2).jpeg": 5057,
	"./WhatsApp Image 2025-11-17 at 07.08.23 (3).jpeg": 8692,
	"./WhatsApp Image 2025-11-17 at 07.08.23.jpeg": 7708,
	"./WhatsApp Image 2025-11-17 at 07.08.24.jpeg": 3705,
	"./WhatsApp Image 2025-11-17 at 07.08.26 (1).jpeg": 9621,
	"./WhatsApp Image 2025-11-17 at 07.08.26.jpeg": 8911,
	"./WhatsApp Image 2025-11-17 at 07.08.27 (1).jpeg": 210,
	"./WhatsApp Image 2025-11-17 at 07.08.27 (2).jpeg": 5389,
	"./WhatsApp Image 2025-11-17 at 07.08.27 (3).jpeg": 6416,
	"./WhatsApp Image 2025-11-17 at 07.08.27 (4).jpeg": 7691,
	"./WhatsApp Image 2025-11-17 at 07.08.27.jpeg": 4968,
	"./WhatsApp Image 2025-11-17 at 07.08.28 (1).jpeg": 5339,
	"./WhatsApp Image 2025-11-17 at 07.08.28 (2).jpeg": 7596,
	"./WhatsApp Image 2025-11-17 at 07.08.28 (3).jpeg": 6761,
	"./WhatsApp Image 2025-11-17 at 07.08.28.jpeg": 9941,
	"./WhatsApp Image 2025-11-17 at 07.08.29 (1).jpeg": 3944,
	"./WhatsApp Image 2025-11-17 at 07.08.29 (2).jpeg": 1287,
	"./WhatsApp Image 2025-11-17 at 07.08.29 (3).jpeg": 9914,
	"./WhatsApp Image 2025-11-17 at 07.08.29.jpeg": 254,
	"./WhatsApp Image 2025-11-17 at 07.08.30 (1).jpeg": 9094,
	"./WhatsApp Image 2025-11-17 at 07.08.30 (2).jpeg": 1633,
	"./WhatsApp Image 2025-11-17 at 07.08.30 (3).jpeg": 9748,
	"./WhatsApp Image 2025-11-17 at 07.08.30.jpeg": 6732,
	"./WhatsApp Image 2025-11-24 at 07.43.13 (1).jpeg": 800,
	"./WhatsApp Image 2025-11-24 at 07.43.13.jpeg": 9126,
	"./WhatsApp Image 2025-11-24 at 07.43.16.jpeg": 7817,
	"./WhatsApp Image 2025-11-24 at 07.43.18.jpeg": 811,
	"./WhatsApp Image 2025-11-24 at 07.43.19 (1).jpeg": 3086,
	"./WhatsApp Image 2025-11-24 at 07.43.19.jpeg": 7476,
	"./WhatsApp Image 2025-11-24 at 07.43.20 (1).jpeg": 5230,
	"./WhatsApp Image 2025-11-24 at 07.43.20 (2).jpeg": 7993,
	"./WhatsApp Image 2025-11-24 at 07.43.20.jpeg": 7876,
	"./WhatsApp Image 2025-11-24 at 07.43.21 (1).jpeg": 497,
	"./WhatsApp Image 2025-11-24 at 07.43.21 (2).jpeg": 6742,
	"./WhatsApp Image 2025-11-24 at 07.43.21.jpeg": 1259,
	"./WhatsApp Image 2025-11-24 at 07.43.22 (1).jpeg": 9496,
	"./WhatsApp Image 2025-11-24 at 07.43.22 (2).jpeg": 4647,
	"./WhatsApp Image 2025-11-24 at 07.43.22.jpeg": 990,
	"./WhatsApp Image 2025-11-24 at 07.43.23 (1).jpeg": 827,
	"./WhatsApp Image 2025-11-24 at 07.43.23 (2).jpeg": 956,
	"./WhatsApp Image 2025-11-24 at 07.43.23.jpeg": 2949,
	"./WhatsApp Image 2025-11-24 at 07.43.24 (1).jpeg": 1114,
	"./WhatsApp Image 2025-11-24 at 07.43.24 (2).jpeg": 1301,
	"./WhatsApp Image 2025-11-24 at 07.43.24.jpeg": 7936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3743;